import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import {
  heroBars3BottomLeft,
  heroBell,
  heroPhoto,
  heroPlus,
  heroSquare3Stack3d,
  heroUsers,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { AuthService } from 'app/auth/auth.service';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { IconComponent } from "app/shared/icon/icon.component";
import { AvatarContainerComponent } from "app/shared/avatar/avatar-container/avatar-container.component";
import { TitleComponent } from "app/shared/title/title.component";
import { AddStoryComponent } from "app/my-history/story/add-story/add-story.component";
import { routePath } from "app/shared/app.config";
import { GuestHeaderComponent } from "../my-history/guest/guest-header/guest-header.component";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-header-layout',
  standalone: true,
  imports: [
    SideMenuComponent,
    IconComponent,
    AvatarContainerComponent,
    TitleComponent,
    RouterLink,
    RouterLinkActive,
    AddStoryComponent,
    GuestHeaderComponent,
    RouterOutlet,
    NgIf,
  ],
  providers: [
    provideIcons({
      heroUsers,
      heroBars3BottomLeft,
      heroSquare3Stack3d,
      heroPhoto,
      heroBell,
      heroPlus,
      heroXMark,
    }),
  ],
  templateUrl: './header-layout.component.html',
  styleUrl: './header-layout.component.scss',
})
export class HeaderLayoutComponent {
  user = inject(AuthService).user;
  protected readonly routePath = routePath;
}
